import script from "./moPurchaseListDetail.vue?vue&type=script&setup=true&name=moPurcharseListDetail&lang=js"
export * from "./moPurchaseListDetail.vue?vue&type=script&setup=true&name=moPurcharseListDetail&lang=js"

const __exports__ = script;

export default __exports__